import netflix from "../../assets/images/clientsSlider/netflix.png";
import meta from "../../assets/images/clientsSlider/meta.png";
import bayer from "../../assets/images/clientsSlider/bayer.png";
import cnn from "../../assets/images/clientsSlider/cnn_brasil.png";
import vale from "../../assets/images/clientsSlider/vale.png";
import xpinvestimentos from "../../assets/images/clientsSlider/xp.png";
import rockinrio from "../../assets/images/clientsSlider/rock_in_rio.png";
import microsoft from "../../assets/images/clientsSlider/microsoft.png";
import olx from "../../assets/images/clientsSlider/olx.png";
import nove9 from "../../assets/images/clientsSlider/99.png";
import activision from "../../assets/images/clientsSlider/activision.png";
import dow from "../../assets/images/clientsSlider/dow.png";
import outback from "../../assets/images/clientsSlider/outback.png";
import chillibeans from "../../assets/images/clientsSlider/chilli_beans.png";
import marykay from "../../assets/images/clientsSlider/mary_kay.png";
import cocacola from "../../assets/images/clientsSlider/coca_cola.png";
import bradesco from "../../assets/images/clientsSlider/bradesco.png";
import roche from "../../assets/images/clientsSlider/roche.png";
import movile from "../../assets/images/clientsSlider/movile.png";

export default [
  {
    index: 1,
    image: netflix,
  },
  {
    index: 2,
    image: meta,
  },
  {
    index: 3,
    image: bayer,
  },
  {
    index: 4,
    image: cnn,
  },
  {
    index: 5,
    image: vale,
  },
  {
    index: 7,
    image: xpinvestimentos,
  },
  {
    index: 8,
    image: rockinrio,
  },
  {
    index: 19,
    image: microsoft,
  },
  {
    index: 20,
    image: olx,
  },
  {
    index: 11,
    image: dow,
  },
  {
    index: 18,
    image: chillibeans,
  },
  {
    index: 6,
    image: activision,
  },
  {
    index: 23,
    image: outback,
  },
  {
    index: 22,
    image: nove9,
  },
];
